module.exports = __webpack_public_path__ + "img/ics_o_chevron_sort_desc.5f45d4e2.svg";